import ToolTip from './Tooltip';

export default ToolTip;
